import { ExternalRiderType } from 'models/external-rider.model';
import { ENUM_AUTHORIZE_TYPE, ENUM_RIDER_STATUS } from 'utils/enum';

export type DefaultOptionsType = {
  name: string;
  id: string;
  icon: JSX.Element;
  onClick: (rider: ExternalRiderType) => void;
  className: string;
};

export const ridersPillDetails = [
  {
    name: 'All',
    id: ENUM_RIDER_STATUS.ALL
  },
  {
    name: 'Approved',
    id: ENUM_RIDER_STATUS.APPROVED
  },
  {
    name: 'Awaiting in person approval',
    id: ENUM_RIDER_STATUS.AWAITING_APPROVAL
  },
  {
    name: 'Scheduled',
    id: ENUM_RIDER_STATUS.SCHEDULED
  },
  {
    name: 'Rejected',
    id: ENUM_RIDER_STATUS.REJECTED
  }
];

export const ridersAuthorizationStatus = {
  [ENUM_AUTHORIZE_TYPE.APPROVE]: 'Rider(s) application approved successfully',
  [ENUM_AUTHORIZE_TYPE.REJECT]: 'Rider(s) application rejected successfully',
  [ENUM_AUTHORIZE_TYPE.DELETE]: 'Rider(s) application deleted successfully',
  [ENUM_AUTHORIZE_TYPE.SCHEDULE]: 'Rider(s) scheduled successfully'
};

export const getTableHeaders = (status: string) => {
  switch (status) {
    case ENUM_RIDER_STATUS.ALL:
      return ['Rider Name', 'Email address', 'Phone number', 'Date added', 'Status', 'Actions', ''];

    case ENUM_RIDER_STATUS.APPROVED:
      return [
        'Rider Name',
        'Email address',
        'Date added',
        'Phone number',
        'Date approved',
        'Actions',
        ''
      ];

    case ENUM_RIDER_STATUS.AWAITING_APPROVAL:
      return ['Rider Name', 'Email address', 'Date added', 'Phone number', 'Actions', ''];

    case ENUM_RIDER_STATUS.REJECTED:
      return [
        'Rider Name',

        'Email address',
        'Date added',
        'Phone number',
        'Date rejected',

        'Actions',
        ''
      ];

    case ENUM_RIDER_STATUS.SCHEDULED:
      return ['Rider Name', 'Scheduled date', 'Scheduled time', 'Location', 'Actions', ''];

    default:
      return [];
  }
};

export const rejectRiderReasons = [
  'national_identity_number',
  'selfie',
  'bike_image',
  'road_worthiness',
  'vehicle Type'
];

export const otherReasons = [
  'bank_account_name',
  'bank_account_number',
  'bank_name',
  'bike_capacity',
  'plate_number',
  'mot',
  'lassa',
  'mid_year_licence',
  'hackney_permit',
  'insurance',
  'pickup-location'
];

export const filterDropdownOptions = (
  rider: ExternalRiderType,
  defaultOptions: DefaultOptionsType[]
) => {
  switch (rider.status) {
    case ENUM_RIDER_STATUS.APPROVED:
    case ENUM_RIDER_STATUS.REJECTED:
      return defaultOptions.filter((option) => option.name === 'Delete');
    case ENUM_RIDER_STATUS.AWAITING_APPROVAL:
      return defaultOptions.filter((option) => option.id !== ENUM_RIDER_STATUS.APPROVED);
    case ENUM_RIDER_STATUS.SCHEDULED:
      return defaultOptions.filter((option) => option.id !== ENUM_RIDER_STATUS.SCHEDULED);
    default:
      return defaultOptions;
  }
};
